@if (lineChartData().datasets.length) {
  <div class="chart-container">
    <canvas
      baseChart
      [data]="lineChartData()"
      [options]="lineChartOptions()"
      [type]="lineChartType()"
    ></canvas>
  </div>
} @else {
  <div class="no-data">
    {{ getNoDataMessage() }}
  </div>
}
